import React from "react";
import styled from "styled-components";

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  max-height: 600px;
  max-width: 100%;
  margin: 0 auto auto;
  position: sticky;
  top: 174px;
`;

const ProductModel = ({ image, altText }) => {
  return <StyledImage src={image} alt={altText || "product"} />;
};

export default ProductModel;
